import { render } from "./Abhs.vue?vue&type=template&id=ae0a093a&scoped=true"
import script from "./Abhs.vue?vue&type=script&lang=js"
export * from "./Abhs.vue?vue&type=script&lang=js"

import "./Abhs.vue?vue&type=style&index=0&id=ae0a093a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0a093a"]])

export default __exports__